/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Container } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';
import { UniversalLink } from '@plone/volto/components';
import cx from 'classnames';

const messages = defineMessages({
  view_all: { id: 'Vedi tutto', defaultMessage: 'Vedi tutto' },
});

interface VariationWrapperProps {
  variation: string;
  show_block_bg: boolean;
  image_bg: Array<any>;
  color_title: string;
  items: [];
  title: string;
  children: object;
  linkTitle: string;
  linkHref: [{ '@id': string }];
}

const VariationWrapper: React.FC<VariationWrapperProps> = (data) => {
  const intl = useIntl();

  const {
    variation,
    show_block_bg,
    image_bg,
    color_title,
    items,
    title,
    children,
    linkTitle,
    linkHref,
  } = data;

  const linkMore = linkHref?.[0]?.['@id'];

  // Background image
  const imageBgSize = 'leadimage';
  const imageObj = image_bg?.[0];
  const image = imageObj
    ? imageObj.image?.scales?.[imageBgSize]?.download ||
      imageObj['@id'] + '/@@images/image/' + imageBgSize
    : null;
  const imageUrl = image ? flattenToAppURL(image) : null;

  const content = (
    <Container className="variation-content">
      {data.title && (
        <div className="block-title">
          <h2
            className={cx({
              'title-black': color_title === 'black',
              'title-white': color_title === 'white',
            })}
          >
            {title}
          </h2>
        </div>
      )}

      <div className="listing-items-wrapper">{children}</div>

      {linkMore && (
        <div className={`link-more`}>
          <UniversalLink
            href={flattenToAppURL(linkMore)}
            className="ui button primary"
          >
            {linkTitle || intl.formatMessage(messages.view_all)}
          </UniversalLink>
        </div>
      )}
    </Container>
  );
  return items?.length > 0 ? (
    <div className={`listing-template ${variation}`}>
      {show_block_bg ? (
        <>
          {imageUrl ? (
            <div
              className="full-width block-bg bg-image"
              style={{
                backgroundImage: `url(${imageUrl})`,
              }}
            >
              {content}
            </div>
          ) : (
            <div className="full-width block-bg">{content}</div>
          )}
        </>
      ) : (
        <>{content}</>
      )}
    </div>
  ) : null;
};

export default VariationWrapper;
